import { ModuleConsts } from 'client/util/Constants';

const { staged } = ModuleConsts.systemUser.accountStates;
const defaultEnrollmentValue = '7';

export default {
  data: () => ({
    mfaEnrollmentValue: defaultEnrollmentValue,
  }),

  methods: {
    /**
     * Creates the exclusion period by adding the number of days entered by the user to the
     * current date.
     * @return {String} [returns the ISO timestamp of the new exclusion period]
     */
    getExclusionUntil() {
      const mfaEnrollmentValue = Number(this.mfaEnrollmentValue);
      if (Number.isNaN(mfaEnrollmentValue)) {
        return -1;
      }
      const exclusionUntil = new Date();
      exclusionUntil.setDate(exclusionUntil.getDate() + mfaEnrollmentValue);
      return exclusionUntil.toISOString();
    },

    getMfaPayload(userState) {
      let payload;

      if (userState === staged) {
        payload = {
          exclusion: true,
          exclusionDays: this.exclusionDays(),
        };
      } else {
        payload = {
          exclusion: true,
          exclusionUntil: this.getExclusionUntil(),
        };
      }

      return payload;
    },

    exclusionDays() {
      return Number(this.mfaEnrollmentValue);
    },

    /**
     * Reset the enrollment value to the default when after it was changed
     * in a modal
     */
    resetMfaEnrollmentValue() {
      this.mfaEnrollmentValue = defaultEnrollmentValue;
    },
  },
};
